import * as React from 'react';
import cx from 'classnames';
import Loader from 'components/Common/Loader/Loader';
import styles from './InfiniteScroll.css';
import ObserverElement from '../ObserverElement/ObserverElement';
import { ORIENTATION } from 'constants/common';
class InfiniteScroll extends React.Component {
    constructor(props) {
        super(props);
        this.onSuccess = () => {
            this.setState(state => {
                this.props.loadMore(state.page);
                const page = state.page + 1;
                return { page, isLoading: false };
            });
        };
        this.setRootRef = c => {
            if (typeof this.props.innerRef === 'function') {
                this.props.innerRef(c);
            }
            this.root = c;
        };
        this.setContainerRef = () => {
            if (this.props.observeSelf) {
                return this.root;
            }
        };
        this.state = {
            page: props.startPage || 0,
            isLoading: !!props.hasMore
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState(({ page }) => ({
            page: nextProps.startPage && this.props.startPage !== nextProps.startPage ? nextProps.startPage : page,
            isLoading: true
        }));
    }
    render() {
        return (<div ref={this.setRootRef} className={this.props.className}>
				{this.props.children}
				{this.props.hasMore && this.state.isLoading ? (<div className={cx(styles['loader'], this.props.loaderClass)}>
						<Loader className={this.props.loaderContainerClass} {...this.props.loaderProps}/>
					</div>) : null}
				{this.props.hasMore ? (<ObserverElement onShow={this.onSuccess} setParentContainerRef={this.setContainerRef} orientation={this.props.orientation} threshold={this.props.threshold} once={this.props.once}/>) : null}
			</div>);
    }
}
InfiniteScroll.defaultProps = {
    orientation: ORIENTATION.VERTICAL
};
export default InfiniteScroll;
